import Model from '@/models/ExtendModel'

export default class WhFamily extends Model {
    resource() {
        return 'wh_family'
    }
}